export const translations = {
  en: {
    home: "Home",
    back: "Back",
    resources: "Resources",
    students: "Students",
    courses: "Courses",
    evaluations: "Evaluations",
    jankiRam: "Janki Ram",
    teacher: "Teacher",
    accountSettings: "Account settings",
    signOut: "Sign out",
    theme: "Theme",
    dark: "Dark",
    light: "Light",
    mode: "Mode",
    mock: "Mock",
    live: "Live",
    search: "Search",
    recentEvaluations: "Recent Evaluations",
    failedToLoadQuestions: "failed to load questions",
    assignmentsFor: "Assignments for Evaluation - ",
    noAssignmentsFound: "No Assignments found",
    correctAnswers: "correct answer(s)",
    createEvaluation: "Create Evaluation",
    manageCourses: "Manage your courses and evaluations.",
    loadingCourses: "Loading courses...",
    noCoursesFound: "No courses found.",
    myBatches: "My Batches",
    viewManageBatches: "View and manage batches for this course.",
    goBackToCourses: "Go back to courses",
    createBatch: "Create batch",
    loadingBatches: "Loading batches...",
    noBatchesFound: "No batches found.",
    viewManageStudentRoster: "View and manage your student roster.",
    addStudent: "Add student",
    loadingStudents: "Loading students...",
    noStudentsFound: "No students found.",
    manageReviewEvaluations: "Manage and review student evaluations.",
    loadingEvaluations: "Loading evaluations...",
    noEvaluationsFound: "No evaluations found.",
    evaluationSuccessfullyCreated: "Evaluation is successfully created.",
    switchedTo: "Switched to",
    checkConsoleForDetails: "Check console for details.",
    failedToFetchData: "Failed to fetch data from",
    edit: "Edit",
    language: "Language",
    english: "English",
    spanish: "Spanish",
    createCourse: "Create Course",
    updateCourse: "Update Course",
    courseName: "Course Name",
    curriculum: "Curriculum",
    class: "Class",
    subject: "Subject",
    fees: "Fees",
    description: "Description",
    durationMonths: "Duration (Months)",
    startDate: "Start Date",
    endDate: "End Date",
    isActive: "Is Active",
    create: "Create",
    cancel: "Cancel",
    update: "Update",
    batchName: "Batch Name",
    slotFrom: "Slot From",
    slotTo: "Slot To",
    batchCapacity: "Batch Capacity",
    location: "Location",
    status: "Status",
    createOrUpdateCourse:
      "Please enter these basic details to create/update a course.",
    createOrUpdateBatch:
      "Please enter these basic details to create/update a batch.",
    course: "Course",
    courseUpdatedSuccessfully: "Course updated successfully!",
    courseCreatedSuccessfully: "Course created successfully!",
    failedToSaveCourse: "Failed to save course.",
    loadingCourseDetails: "Loading course details...",
    batchUpdatedSuccessfully: "Batch updated successfully!",
    batchCreatedSuccessfully: "Batch created successfully!",
    failedToSaveBatch: "Failed to save batch.",
    loadingBatchDetails: "Cargando detalles del grupo...",
    select: "Select",
    updating: "Actualizando...",
    creating: "Creando...",
    pendingEnrollmentRequests: "Pending Enrollment Requests",
    enroll: "Enroll",
    studentRoster: "Student Roster",
    goBackToBatches: "Go back to batches",
    noStudentsInBatch: "No students found in this batch.",
    noPendingRequests: "No pending enrollment requests.",
    createBatchEnrollment: "Create Batch Enrollment",
    updateBatchEnrollment: "Update Batch Enrollment",
    enrollmentDetails: "Enrollment Details",
    student: "Student",
    batch: "Batch",
    enrollmentDate: "Enrollment Date",
    feePaid: "Fee Paid",
    paymentDate: "Payment Date",
    tutorId: "Tutor ID",
    enrollmentSuccessfullyCreated: "Enrollment successfully created!",
    enrollmentSuccessfullyUpdated: "Enrollment successfully updated!",
    failedToSaveEnrollment: "Failed to save enrollment.",
    loadingEnrollmentDetails: "Loading enrollment details...",
    studentName: "Student Name",
    studentEmail: "Student Email",
    parentEmail: "Parent Email",
    parentPhone: "Parent Phone",
    gender: "Gender",
    addStudentTitle: "Add a student",
    addStudentSubtitle: "Enter the basic details to onboard a student.",
    studentCreatedSuccessfully: "Student created successfully!",
    studentUpdatedSuccessfully: "Student updated successfully!",
    failedToSaveStudent: "Failed to save student.",
    loadingStudentDetails: "Loading student details...",
    schoolName: "School Name",
    profilePictureUrl: "Profile Picture URL",
    dateOfBirth: "Date of Birth",
    hasLearningDisability: "Has Learning Disability",
    studentsLimit: "Students",
    coursesLimit: "Courses",
    batchesLimit: "Batches",
    studentsPerTutorLimit: "Students per Tutor",
    limitReached: "Limit Reached!",
    currentUsage: "Current Usage",
    subscriptionPlans: "Subscription Plans",
    currentPlan: "Current Plan",
    selectPlan: "Select Plan",
    planFeatures: "Plan Features",
    unlimited: "Unlimited",
    batchEvaluations: "Batch Evaluations",
    manageBatchEvaluations: "Manage evaluations for this batch.",
    noBatchEvaluationsFound: "No evaluations found for this batch.",
    addEvaluation: "Add Evaluation",
    createOrUpdateEvaluation: "Create or update evaluation details.",
    evaluationCreatedSuccessfully: "Evaluation created successfully!",
    evaluationUpdatedSuccessfully: "Evaluation updated successfully!",
    loadingEvaluationDetails: "Loading evaluation details...",
    saving: "Saving...",
    Chapter: "Chapter",
    "Concept Topic": "Concept Topic",
    "Difficulty Level": "Difficulty Level",
    Source: "Source",
    "Number of Questions": "Number of Questions",
    "Max Time (minutes)": "Max Time (minutes)",
    "Expiry Date": "Expiry Date",
    "Duration (seconds)": "Duration (seconds)",
    "Is Practice Evaluation": "Is Practice Evaluation",
    Active: "Active",
    assignEvaluationToBatch: "Assign Evaluation to Batch",
    assignEvaluationToAllStudents:
      "Assign evaluation to all students in the batch",
    selectEvaluation: "Select Evaluation",
    assignEvaluation: "Assign Evaluation",
    sentDateTime: "Sent Date & Time",
    expiryDateTime: "Expiry Date & Time",
    active: "Active",
    assigning: "Assigning...",
    assignToBatch: "Assign to Batch",
    loading: "Loading...",
    selectBatch: "Select Batch",
    viewAssignments: "View Assignments",
    assignEvaluationToBatchSubtitle: "Assign evaluations to specific batches",
    evaluationDetails: "Evaluation Details",
    chapter: "Chapter",
    topic: "Topic",
    difficulty: "Difficulty",
    questions: "Questions",
    timeLimit: "Time Limit",
    minutes: "minutes",
    type: "Type",
    practice: "Practice",
    assessment: "Assessment",
    assignmentDetails: "Assignment Details",
    endDate: "End Date",
    evaluationType: "Evaluation Type",
    selectEvaluationType: "Select Evaluation Type",
    quiz: "Quiz",
    exam: "Exam",
    confirmation: "Confirmation",
    assignmentConfirmation:
      "This will assign the evaluation to the entire batch. All students in the batch will receive this evaluation as an assignment.",
    batchDetails: "Batch Details",
    capacity: "Capacity",
    enrolledStudents: "Enrolled Students",
    noStudentsInBatch: "No students in this batch",
    batchInformation: "Batch Information",
    students: "Students",
    selectBatchToAssign: "Select Batch to Assign",
    evaluationToAssign: "Evaluation to Assign",
    availableBatches: "Available Batches",
    noBatchesAvailable: "No batches available",
    batchAssignments: "Batch Assignments",
    manageBatchAssignments: "Manage assignments for this batch",
    noBatchAssignmentsFound: "No assignments found for this batch",
    evaluationAssignments: "Evaluation Assignments",
    viewEvaluationAssignments: "View assignments for this evaluation",
    noEvaluationAssignmentsFound: "No assignments found for this evaluation",
    totalAssignments: "Total Assignments",
    submittedAssignments: "Submitted",
    pendingAssignments: "Pending",
    expiredAssignments: "Expired",
    assignmentStatus: "Status",
    assignmentScore: "Score",
    assignmentFeedback: "Feedback",
    assignmentTimeTaken: "Time Taken",
    assignmentSubmittedDate: "Submitted Date",
    revokeEvaluation: "Revoke Evaluation",
    evaluationRevokedSuccessfully: "Evaluation revoked successfully",
    failedToRevokeEvaluation: "Failed to revoke evaluation",
    clickToViewAssignments: "Click to view assignments",
    selectChapter: "Select Chapter",
    selectTopic: "Select Topic",
    selectDifficulty: "Select Difficulty",
    selectSource: "Select Source",
    selectEvaluationType: "Select Evaluation Type",
    selectLocation: "Select Location",
    selectStatus: "Select Status",
    selectCurriculum: "Select Curriculum",
    selectAcademicClass: "Select Academic Class",
    selectSubject: "Select Subject",
    enterConceptTopic: "Enter concept topic",
    maxTimeDescription: "Maximum time allowed for the evaluation in minutes",
    durationDescription:
      "Actual duration of the evaluation in seconds (optional)",
    delete: "Delete",
    zeroAssignments: "0 Assignments",
    canEditOrDelete: "Editable / Deletable",
    unusedEvaluationTooltip: "0 assignments — this evaluation is unused and can be edited or deleted.",
    evaluationDeletedSuccessfully: "Evaluation deleted successfully.",
    failedToDeleteEvaluation: "Failed to delete evaluation.",
    confirmDeleteEvaluation: "Are you sure you want to delete this evaluation? This action cannot be undone.",
    inUseAssignments: "In Use",
    editEvaluation: "Edit Evaluation",
    filterZeroAssignments: "0 Assignments (Unused)",
    allEvaluationsFilter: "All",
    archive: "Archive",
    unarchive: "Restore to Active",
    modifyAndReuse: "Modify & Reuse",
    archived: "Archived",
    showArchived: "Show Archived",
    hideArchived: "Showing Archived",
    confirmArchiveEvaluation: "Are you sure you want to archive this evaluation?",
    evaluationArchivedSuccessfully: "Evaluation archived successfully.",
    failedToArchiveEvaluation: "Failed to archive evaluation.",
    evaluationRestoredSuccessfully: "Evaluation restored to active status.",
    failedToRestoreEvaluation: "Failed to restore evaluation.",
    expired: "Expired",
    evaluationExpired: "Expired",
    expiredEvaluationCannotBeModified: "This evaluation has expired and cannot be edited or archived.",
    editAndReuse: "Edit & Reuse",
    expiredInUse: "Expired & In Use",
    expiredInUseNotice: "This evaluation has expired and is in use by student assignments and cannot be modified or archived.",
    expiredZeroAssignmentsTooltip: "0 assignments — this expired evaluation is unused and can be edited or reused.",
  },
  es: {
    home: "Inicio",
    resources: "Recursos",
    students: "Estudiantes",
    courses: "Cursos",
    evaluations: "Evaluaciones",
    jankiRam: "Janki Ram",
    teacher: "Profesor",
    accountSettings: "Configuración de cuenta",
    signOut: "Cerrar sesión",
    theme: "Tema",
    dark: "Oscuro",
    light: "Claro",
    mode: "Modo",
    mock: "Simulación",
    live: "En Vivo",
    search: "Buscar",
    createEvaluation: "Crear Evaluación",
    manageCourses: "Administra tus cursos y evaluaciones.",
    loadingCourses: "Cargando cursos...",
    noCoursesFound: "No se encontraron cursos.",
    myBatches: "Mis Grupos",
    viewManageBatches: "Ver y administrar grupos para este curso.",
    goBackToCourses: "Volver a cursos",
    createBatch: "Crear grupo",
    loadingBatches: "Cargando grupos...",
    noBatchesFound: "No se encontraron grupos.",
    viewManageStudentRoster: "Ver y administrar tu lista de estudiantes.",
    addStudent: "Añadir estudiante",
    loadingStudents: "Cargando estudiantes...",
    noStudentsFound: "No se encontraron estudiantes.",
    manageReviewEvaluations:
      "Administrar y revisar evaluaciones de estudiantes.",
    loadingEvaluations: "Cargando evaluaciones...",
    noEvaluationsFound: "No se encontraron evaluaciones.",
    evaluationSuccessfullyCreated: "Evaluación creada exitosamente.",
    switchedTo: "Cambiado a",
    checkConsoleForDetails: "Verifica la consola para más detalles.",
    failedToFetchData: "Error al obtener datos de",
    edit: "Editar",
    language: "Idioma",
    english: "Inglés",
    spanish: "Español",
    createCourse: "Crear Curso",
    updateCourse: "Actualizar Curso",
    courseName: "Nombre del Curso",
    curriculum: "Plan de Estudios",
    class: "Clase",
    subject: "Asignatura",
    fees: "Tarifas",
    description: "Descripción",
    durationMonths: "Duración (Meses)",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    isActive: "Está Activo",
    create: "Crear",
    cancel: "Cancelar",
    update: "Actualizar",
    batchName: "Nombre del Grupo",
    slotFrom: "Franja Horaria Desde",
    slotTo: "Franja Horaria Hasta",
    batchCapacity: "Capacidad del Grupo",
    location: "Ubicación",
    status: "Estado",
    createOrUpdateCourse:
      "Ingrese los detalles básicos para crear/actualizar un curso.",
    createOrUpdateBatch:
      "Ingrese los detalles básicos para crear/actualizar un grupo.",
    course: "Curso",
    courseUpdatedSuccessfully: "Curso actualizado exitosamente!",
    courseCreatedSuccessfully: "Curso creado exitosamente!",
    failedToSaveCourse: "Error al guardar el curso.",
    loadingCourseDetails: "Cargando detalles del curso...",
    batchUpdatedSuccessfully: "Grupo actualizado exitosamente!",
    batchCreatedSuccessfully: "Grupo creado exitosamente!",
    failedToSaveBatch: "Error al guardar el grupo.",
    loadingBatchDetails: "Cargando detalles del grupo...",
    select: "Seleccionar",
    updating: "Actualizando...",
    creating: "Creando...",
    pendingEnrollmentRequests: "Solicitudes de Inscripción Pendientes",
    enroll: "Inscribir",
    studentRoster: "Lista de Estudiantes",
    goBackToBatches: "Volver a grupos",
    noStudentsInBatch: "No se encontraron estudiantes en este grupo.",
    noPendingRequests: "No hay solicitudes de inscripción pendientes.",
    createBatchEnrollment: "Crear Inscripción de Grupo",
    updateBatchEnrollment: "Actualizar Inscripción de Grupo",
    enrollmentDetails: "Detalles de Inscripción",
    student: "Estudiante",
    batch: "Grupo",
    enrollmentDate: "Fecha de Inscripción",
    feePaid: "Tarifa Pagada",
    paymentDate: "Fecha de Pago",
    tutorId: "ID del Tutor",
    enrollmentSuccessfullyCreated: "¡Inscripción creada exitosamente!",
    enrollmentSuccessfullyUpdated: "¡Inscripción actualizada exitosamente!",
    failedToSaveEnrollment: "Error al guardar la inscripción.",
    loadingEnrollmentDetails: "Cargando detalles de inscripción...",
    studentName: "Nombre del Estudiante",
    studentEmail: "Correo Electrónico del Estudiante",
    parentEmail: "Correo Electrónico del Padre",
    parentPhone: "Teléfono del Padre",
    gender: "Género",
    addStudentTitle: "Añadir un estudiante",
    addStudentSubtitle:
      "Ingrese los detalles básicos para incorporar un estudiante.",
    studentCreatedSuccessfully: "¡Estudiante creado exitosamente!",
    studentUpdatedSuccessfully: "¡Estudiante actualizado exitosamente!",
    failedToSaveStudent: "Error al guardar el estudiante.",
    loadingStudentDetails: "Cargando detalles del estudiante.",
    schoolName: "Nombre de la Escuela",
    profilePictureUrl: "URL de la Imagen de Perfil",
    dateOfBirth: "Fecha de Nacimiento",
    hasLearningDisability: "Tiene Discapacidad de Aprendizaje",
    studentsLimit: "Estudiantes",
    coursesLimit: "Cursos",
    batchesLimit: "Grupos",
    studentsPerTutorLimit: "Estudiantes por Tutor",
    limitReached: "¡Límite Alcanzado!",
    currentUsage: "Uso Actual",
    subscriptionPlans: "Planes de Suscripción",
    currentPlan: "Plan Actual",
    selectPlan: "Seleccionar Plan",
    planFeatures: "Características del Plan",
    unlimited: "Ilimitado",
    batchEvaluations: "Evaluaciones del Grupo",
    manageBatchEvaluations: "Administrar evaluaciones para este grupo.",
    noBatchEvaluationsFound: "No se encontraron evaluaciones para este grupo.",
    addEvaluation: "Añadir Evaluación",
    createOrUpdateEvaluation: "Crear o actualizar detalles de evaluación.",
    evaluationCreatedSuccessfully: "¡Evaluación creada exitosamente!",
    evaluationUpdatedSuccessfully: "¡Evaluación actualizada exitosamente!",
    loadingEvaluationDetails: "Cargando detalles de evaluación...",
    saving: "Guardando...",
    Chapter: "Capítulo",
    "Concept Topic": "Tema del Concepto",
    "Difficulty Level": "Nivel de Dificultad",
    Source: "Fuente",
    "Number of Questions": "Número de Preguntas",
    "Max Time (minutes)": "Tiempo Máximo (minutos)",
    "Expiry Date": "Fecha de Vencimiento",
    "Duration (seconds)": "Duración (segundos)",
    "Is Practice Evaluation": "Es Evaluación de Práctica",
    Active: "Activo",
    assignEvaluationToBatch: "Asignar Evaluación al Grupo",
    assignEvaluationToAllStudents:
      "Asignar evaluación a todos los estudiantes del grupo",
    selectEvaluation: "Seleccionar Evaluación",
    assignEvaluation: "Asignar Evaluación",
    sentDateTime: "Fecha y Hora de Envío",
    expiryDateTime: "Fecha y Hora de Vencimiento",
    active: "Activo",
    assigning: "Asignando...",
    assignToBatch: "Asignar al Grupo",
    loading: "Cargando...",
    selectBatch: "Seleccionar Grupo",
    viewAssignments: "Ver Asignaciones",
    assignEvaluationToBatchSubtitle:
      "Asignar evaluaciones a grupos específicos",
    evaluationDetails: "Detalles de la Evaluación",
    chapter: "Capítulo",
    topic: "Tema",
    difficulty: "Dificultad",
    questions: "Preguntas",
    timeLimit: "Límite de Tiempo",
    minutes: "minutos",
    type: "Tipo",
    practice: "Práctica",
    assessment: "Evaluación",
    assignmentDetails: "Detalles de la Asignación",
    endDate: "Fecha de Fin",
    evaluationType: "Tipo de Evaluación",
    selectEvaluationType: "Seleccionar Tipo de Evaluación",
    quiz: "Cuaderno de Ejercicios",
    exam: "Examen",
    confirmation: "Confirmación",
    assignmentConfirmation:
      "Esto asignará la evaluación a todo el grupo. Todos los estudiantes del grupo recibirán esta evaluación como una asignación.",
    batchDetails: "Detalles del Grupo",
    capacity: "Capacidad",
    enrolledStudents: "Estudiantes Inscritos",
    noStudentsInBatch: "No hay estudiantes en este grupo",
    batchInformation: "Información del Grupo",
    students: "Estudiantes",
    selectBatchToAssign: "Seleccionar Grupo para Asignar",
    evaluationToAssign: "Evaluación para Asignar",
    availableBatches: "Grupos Disponibles",
    noBatchesAvailable: "No hay grupos disponibles",
    batchAssignments: "Asignaciones de Grupo",
    manageBatchAssignments: "Administrar asignaciones para este grupo",
    noBatchAssignmentsFound: "No se encontraron asignaciones para este grupo",
    evaluationAssignments: "Asignaciones de Evaluación",
    viewEvaluationAssignments: "Ver asignaciones para esta evaluación",
    noEvaluationAssignmentsFound:
      "No se encontraron asignaciones para esta evaluación",
    totalAssignments: "Total de Asignaciones",
    submittedAssignments: "Presentadas",
    pendingAssignments: "Pendientes",
    expiredAssignments: "Expiradas",
    assignmentStatus: "Estado",
    assignmentScore: "Puntuación",
    assignmentFeedback: "Comentario",
    assignmentTimeTaken: "Tiempo Tomado",
    assignmentSubmittedDate: "Fecha de Envío",
    revokeEvaluation: "Revocar Evaluación",
    evaluationRevokedSuccessfully: "¡Evaluación revocada exitosamente!",
    failedToRevokeEvaluation: "Error al revocar la evaluación.",
    clickToViewAssignments: "Haga clic para ver las asignaciones",
    selectChapter: "Seleccionar Capítulo",
    selectTopic: "Seleccionar Tema",
    selectDifficulty: "Seleccionar Dificultad",
    selectSource: "Seleccionar Fuente",
    selectEvaluationType: "Seleccionar Tipo de Evaluación",
    selectLocation: "Seleccionar Ubicación",
    selectStatus: "Seleccionar Estado",
    selectCurriculum: "Seleccionar Currículo",
    selectAcademicClass: "Seleccionar Clase Académica",
    selectSubject: "Seleccionar Asignatura",
    enterConceptTopic: "Ingrese concepto tema",
    maxTimeDescription: "Tiempo máximo permitido para la evaluación en minutos",
    durationDescription:
      "Duración actual de la evaluación en segundos (opcional)",
    delete: "Eliminar",
    zeroAssignments: "0 Asignaciones",
    canEditOrDelete: "Editable / Eliminable",
    unusedEvaluationTooltip: "0 asignaciones — esta evaluación no se usa y se puede editar o eliminar.",
    evaluationDeletedSuccessfully: "Evaluación eliminada exitosamente.",
    failedToDeleteEvaluation: "Error al eliminar la evaluación.",
    confirmDeleteEvaluation: "¿Está seguro de que desea eliminar esta evaluación? Esta acción no se puede deshacer.",
    inUseAssignments: "En Uso",
    editEvaluation: "Editar Evaluación",
    filterZeroAssignments: "0 Asignaciones (Sin uso)",
    allEvaluationsFilter: "Todas",
    archive: "Archivar",
    unarchive: "Restaurar a Activo",
    modifyAndReuse: "Modificar y Reutilizar",
    archived: "Archivado",
    showArchived: "Mostrar Archivadas",
    hideArchived: "Mostrando Archivadas",
    confirmArchiveEvaluation: "¿Está seguro de que desea archivar esta evaluación?",
    evaluationArchivedSuccessfully: "Evaluación archivada exitosamente.",
    failedToArchiveEvaluation: "Error al archivar la evaluación.",
    evaluationRestoredSuccessfully: "Evaluación restaurada a estado activo.",
    failedToRestoreEvaluation: "Error al restaurar la evaluación.",
    expired: "Vencido",
    evaluationExpired: "Vencido (Solo lectura)",
    expiredEvaluationCannotBeModified: "Esta evaluación ha vencido y no se puede editar ni archivar.",
    editAndReuse: "Editar y Reutilizar",
    expiredInUse: "Vencido y En Uso",
    expiredInUseNotice: "Esta evaluación ha vencido y está en uso por asignaciones de estudiantes, por lo que no se puede modificar ni archivar.",
    expiredZeroAssignmentsTooltip: "0 asignaciones: esta evaluación vencida no tiene uso y puede editarse o reutilizarse.",
  },
};
